<div class="section" id="skill">
    <div class="container">
      <div class="h4 text-center mb-4 title"> Tech Skills</div>
      <div class="card" data-aos="fade-up" data-aos-anchor-placement="top-bottom">
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <div class="progress-container progress-primary">
                <span class="progress-badge">JavaScript</span>
                <div class="progress">
                  <div class="progress-bar progress-bar-primary" data-aos="progress-full" data-aos-offset="10"
                    data-aos-duration="2000" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"
                    style="width: 90%;"></div>
                  <span class="progress-value">90%</span>
                </div>
              </div>
            </div>
             <div class="col-md-6">
              <div class="progress-container progress-primary">
                <span class="progress-badge">TypeScript</span>
                <div class="progress">
                  <div class="progress-bar progress-bar-primary" data-aos="progress-full" data-aos-offset="10"
                    data-aos-duration="2000" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"
                    style="width: 90%;"></div>
                  <span class="progress-value">70%</span>
                </div>
              </div>
            </div>
             <div class="col-md-6">
              <div class="progress-container progress-primary">
                <span class="progress-badge">NodeJS</span>
                <div class="progress">
                  <div class="progress-bar progress-bar-primary" data-aos="progress-full" data-aos-offset="10"
                    data-aos-duration="2000" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"
                    style="width: 90%;"></div>
                  <span class="progress-value">80%</span>
                </div>
              </div>
            </div>
            
            <div class="col-md-6">
              <div class="progress-container progress-primary">
                <span class="progress-badge">React JS, NextJS, VueJS</span>
                <div class="progress">
                  <div class="progress-bar progress-bar-primary" data-aos="progress-full" data-aos-offset="10"
                    data-aos-duration="2000" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"
                    style="width: 90%;"></div>
                  <span class="progress-value">90%</span>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="progress-container progress-primary">
                <span class="progress-badge">Angular</span>
                <div class="progress">
                  <div class="progress-bar progress-bar-striped progress-bar-animated" data-aos="progress-full" data-aos-offset="10"
                    data-aos-duration="2000" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"
                    style="width: 85%;"></div>
                  <span class="progress-value">85%</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="progress-container progress-primary">
                <span class="progress-badge">Python</span>
                <div class="progress">
                  <div class="progress-bar progress-bar-primary" data-aos="progress-full" data-aos-offset="10"
                    data-aos-duration="2000" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"
                    style="width: 85%;"></div>
                  <span class="progress-value">85%</span>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="progress-container progress-primary">
                <span class="progress-badge">Java</span>
                <div class="progress">
                  <div class="progress-bar progress-bar-primary" data-aos="progress-full" data-aos-offset="10"
                    data-aos-duration="2000" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"
                    style="width: 60%;"></div>
                  <span class="progress-value">70%</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="progress-container progress-primary">
                <span class="progress-badge">SQL, MYSQL, POSTGRES AND DB2</span>
                <div class="progress">
                  <div class="progress-bar progress-bar-primary" data-aos="progress-full" data-aos-offset="10"
                    data-aos-duration="2000" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"
                    style="width: 75%;"></div>
                  <span class="progress-value">75%</span>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="progress-container progress-primary">
                <span class="progress-badge">HTML,CSS, TAILWIND, MATERIALUI, CSS FRAMEWORKS</span>
                <div class="progress">
                  <div class="progress-bar progress-bar-primary" data-aos="progress-full" data-aos-offset="10"
                    data-aos-duration="2000" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"
                    style="width: 90%;"></div>
                  <span class="progress-value">100%</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="progress-container progress-primary">
                <span class="progress-badge">Jest, Enjyme, Unit Tests</span>
                <div class="progress">
                  <div class="progress-bar progress-bar-primary" data-aos="progress-full" data-aos-offset="10"
                    data-aos-duration="2000" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"
                    style="width: 90%;"></div>
                  <span class="progress-value">80%</span>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="progress-container progress-primary">
                <span class="progress-badge">AWS, S3</span>
                <div class="progress">
                  <div class="progress-bar progress-bar-primary" data-aos="progress-full" data-aos-offset="10"
                    data-aos-duration="2000" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"
                    style="width: 90%;"></div>
                  <span class="progress-value">70%</span>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="progress-container progress-primary">
                <span class="progress-badge">GraphQL</span>
                <div class="progress">
                  <div class="progress-bar progress-bar-primary" data-aos="progress-full" data-aos-offset="10"
                    data-aos-duration="2000" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"
                    style="width: 90%;"></div>
                  <span class="progress-value">70%</span>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="progress-container progress-primary">
                <span class="progress-badge">Docker, Kubernetes</span>
                <div class="progress">
                  <div class="progress-bar progress-bar-primary" data-aos="progress-full" data-aos-offset="10"
                    data-aos-duration="2000" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"
                    style="width: 90%;"></div>
                  <span class="progress-value">70%</span>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="progress-container progress-primary">
                <span class="progress-badge">CI/CD</span>
                <div class="progress">
                  <div class="progress-bar progress-bar-primary" data-aos="progress-full" data-aos-offset="10"
                    data-aos-duration="2000" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"
                    style="width: 90%;"></div>
                  <span class="progress-value">70%</span>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="progress-container progress-primary">
                <span class="progress-badge">Data Analytics, Data Mining, Data Visualization</span>
                <div class="progress">
                  <div class="progress-bar progress-bar-primary" data-aos="progress-full" data-aos-offset="10"
                    data-aos-duration="2000" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"
                    style="width: 60%;"></div>
                  <span class="progress-value">70%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="h4 text-center mb-4 title"> Soft Skills</div>
      <div class="card" data-aos="fade-up" data-aos-anchor-placement="top-bottom">
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <div class="progress-container progress-primary">
                <span class="progress-badge">Communication & Interpersonal</span>
                <div class="progress">
                  <div class="progress-bar progress-bar-primary" data-aos="progress-full" data-aos-offset="10"
                    data-aos-duration="2000" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"
                    style="width: 90%;"></div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="progress-container progress-primary">
                <span class="progress-badge">Leadership</span>
                <div class="progress">
                  <div class="progress-bar progress-bar-striped progress-bar-animated" data-aos="progress-full" data-aos-offset="10"
                    data-aos-duration="2000" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"
                    style="width: 85%;"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
